import React, { useEffect, useState } from "react"
import { TranscriptionSystemRoutes } from 'router'

const TranscriptionSystem = () => {
    const [status, setStatus] = useState(null)

    const commonState = {
        status, setStatus
    }

    return (
        <TranscriptionSystemContext.Provider value={commonState}>
            <TranscriptionSystemRoutes />
        </TranscriptionSystemContext.Provider>
    )
}

export const TranscriptionSystemContext = React.createContext()
export default TranscriptionSystem